import OatsOatmealProduct from 'models/OatsOatmealProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import OatsOatmealPackage from './OatsOatmealPackage'

const productOptions = {
  packagingInfo: <OatsOatmealPackage />,
  productTitle: 'Oats/Oatmeal',
  model: OatsOatmealProduct,
  validCategories: ['16'],
  validSubCategories: ['005'],
}

const OatsOatmeal = () => <ProductForm product={productOptions} />

export default OatsOatmeal

export const getOatsOatmealPackage = newProduct => {
  const newOatsOatmealPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Oats or Oatmeal',
    CookingType: newProduct.CookingType,
    GrainSize: newProduct.GrainSize,
    OatType:
      newProduct.OatType === 'Other'
        ? newProduct.otherType
        : newProduct.OatType,
    OatVariety:
      newProduct.OatVariety === 'Other'
        ? newProduct.otherVariety
        : newProduct.OatVariety,
  }
  return newOatsOatmealPackage
}
export const updateOatsOatmealPackage = newProduct => {
  const newOatsOatmealPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Oats or Oatmeal',
    CookingType: newProduct.CookingType,
    GrainSize: newProduct.GrainSize,
    OatType:
      newProduct.OatType === 'Other'
        ? newProduct.otherType
        : newProduct.OatType,
    OatVariety:
      newProduct.OatVariety === 'Other'
        ? newProduct.otherVariety
        : newProduct.OatVariety,
  }
  return newOatsOatmealPackage
}
